<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <FileTextIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('superadmin.tools.signUp.title') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0"></div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <SignUpListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import SignUpListTable from '@/components/sign-up/SignUpListTable'

export default defineComponent({
  components: {
    SignUpListTable
  },
  setup() {
    return {}
  }
})
</script>
